import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Link as LinkScroll } from "react-scroll";
import Logo from "../../assets/images/logo.png";
import { FEATURE_ID, GENERAL, ROUTE } from '../../Common/constant';

const FooterOne = () => {
    const { pathname } = useLocation()
    const isAtHome = pathname === ROUTE.BASE_URL
    const isContactUs = pathname === ROUTE.CONTACT_US
    const isProducts = pathname.includes(ROUTE.PRODUCTS.BASE_URL)
    const isNewsArticles = pathname === ROUTE.NEWS_ARTICLES

    return (
        <footer id={FEATURE_ID.CONTACT} className="main__footer">
            <div className="footer-top">
                <div className="auto-container">
                    {isContactUs || isNewsArticles ? null : <div className="top-inner">
                        <div className="left__top">
                            <div className="title" style={{ padding: 0 }}>
                                <h2>Looking For best It business solution?</h2>
                            </div>
                        </div>
                        <div className="right__top">
                            <div className="btn-box">
                                <Link to={ROUTE.CONTACT_US} className="theme-btn theme-btn-one"><i className="icon-02"></i> Contact Us</Link>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
            <div className="footer__one">
                <div className="footer-widget-section">
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="col-lg-4 col-md-4 col-sm-12 footer-column">
                                <div className="footer-widget footer-logo-widget wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                                    <figure className="footer-logo">
                                        {isAtHome ?
                                            <LinkScroll to={FEATURE_ID.HOME} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }}><img src={Logo} alt="" /></LinkScroll>
                                            :
                                            <Link to={ROUTE.BASE_URL}><img src={Logo} alt="" /></Link>
                                        }
                                    </figure>
                                    <div className="text">
                                        <p>Our technologies are designed to seamlessly integrate with your existing systems, minimizing disruption and maximizing productivity.</p>
                                    </div>

                                    <div className='social-media-wrapper'>
                                        <p>Connect with us:</p>
                                        <div>
                                            <div>
                                                <Link to={GENERAL.LINKEDIN_URL} target='_blank' rel='noopener noreferrer'>
                                                    <svg
                                                        fill="#ffffff"
                                                        width={24}
                                                        height={24}
                                                        viewBox="-2 -2 24 24"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        preserveAspectRatio="xMinYMin"
                                                        className="jam jam-linkedin"
                                                    >
                                                        <path d="M19.959 11.719v7.379h-4.278v-6.885c0-1.73-.619-2.91-2.167-2.91-1.182 0-1.886.796-2.195 1.565-.113.275-.142.658-.142 1.043v7.187h-4.28s.058-11.66 0-12.869h4.28v1.824l-.028.042h.028v-.042c.568-.875 1.583-2.126 3.856-2.126 2.815 0 4.926 1.84 4.926 5.792zM2.421.026C.958.026 0 .986 0 2.249c0 1.235.93 2.224 2.365 2.224h.028c1.493 0 2.42-.989 2.42-2.224C4.787.986 3.887.026 2.422.026zM.254 19.098h4.278V6.229H.254v12.869z" />
                                                    </svg>
                                                </Link>
                                            </div>
                                            <div>
                                                <Link to={GENERAL.INSTAGRAM_URL} target='_blank' rel='noopener noreferrer'>
                                                    <svg fill="#ffffff" width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="M17.34,5.46h0a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,17.34,5.46Zm4.6,2.42a7.59,7.59,0,0,0-.46-2.43,4.94,4.94,0,0,0-1.16-1.77,4.7,4.7,0,0,0-1.77-1.15,7.3,7.3,0,0,0-2.43-.47C15.06,2,14.72,2,12,2s-3.06,0-4.12.06a7.3,7.3,0,0,0-2.43.47A4.78,4.78,0,0,0,3.68,3.68,4.7,4.7,0,0,0,2.53,5.45a7.3,7.3,0,0,0-.47,2.43C2,8.94,2,9.28,2,12s0,3.06.06,4.12a7.3,7.3,0,0,0,.47,2.43,4.7,4.7,0,0,0,1.15,1.77,4.78,4.78,0,0,0,1.77,1.15,7.3,7.3,0,0,0,2.43.47C8.94,22,9.28,22,12,22s3.06,0,4.12-.06a7.3,7.3,0,0,0,2.43-.47,4.7,4.7,0,0,0,1.77-1.15,4.85,4.85,0,0,0,1.16-1.77,7.59,7.59,0,0,0,.46-2.43c0-1.06.06-1.4.06-4.12S22,8.94,21.94,7.88ZM20.14,16a5.61,5.61,0,0,1-.34,1.86,3.06,3.06,0,0,1-.75,1.15,3.19,3.19,0,0,1-1.15.75,5.61,5.61,0,0,1-1.86.34c-1,.05-1.37.06-4,.06s-3,0-4-.06A5.73,5.73,0,0,1,6.1,19.8,3.27,3.27,0,0,1,5,19.05a3,3,0,0,1-.74-1.15A5.54,5.54,0,0,1,3.86,16c0-1-.06-1.37-.06-4s0-3,.06-4A5.54,5.54,0,0,1,4.21,6.1,3,3,0,0,1,5,5,3.14,3.14,0,0,1,6.1,4.2,5.73,5.73,0,0,1,8,3.86c1,0,1.37-.06,4-.06s3,0,4,.06a5.61,5.61,0,0,1,1.86.34A3.06,3.06,0,0,1,19.05,5,3.06,3.06,0,0,1,19.8,6.1,5.61,5.61,0,0,1,20.14,8c.05,1,.06,1.37.06,4S20.19,15,20.14,16ZM12,6.87A5.13,5.13,0,1,0,17.14,12,5.12,5.12,0,0,0,12,6.87Zm0,8.46A3.33,3.33,0,1,1,15.33,12,3.33,3.33,0,0,1,12,15.33Z" /></svg>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 footer-column">
                                <div className="footer-widget news-letter-widget ml_80 wow fadeInUp animated" data-wow-delay="200ms" data-wow-duration="1500ms">
                                    <div className="widget-title">
                                        <h4>Explore</h4>
                                    </div>
                                    <div className='widget-content'>
                                        <div>
                                            {isAtHome ?
                                                <LinkScroll to={FEATURE_ID.ABOUT} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }}>About Us</LinkScroll>
                                                :
                                                <Link to={ROUTE.BASE_URL}>
                                                    About Us
                                                </Link>
                                            }
                                        </div>
                                        <div>
                                            <Link to={ROUTE.PRODUCTS.BASE_URL} onClick={() => isProducts && window.scrollTo(0, 0)}>
                                                Products
                                            </Link>
                                        </div>
                                        <div>
                                            {isAtHome ?
                                                <LinkScroll to={FEATURE_ID.SERVICE} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }}>Services</LinkScroll>
                                                :
                                                <Link to={ROUTE.BASE_URL}>
                                                    Services
                                                </Link>
                                            }
                                        </div>
                                        <div>
                                            {isAtHome ?
                                                <LinkScroll to={FEATURE_ID.INDUSTRY} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }}>Industries</LinkScroll>
                                                :
                                                <Link to={ROUTE.BASE_URL}>
                                                    Industries
                                                </Link>
                                            }
                                        </div>
                                        <div>
                                            {isAtHome ?
                                                <LinkScroll to={FEATURE_ID.PARTNER_CLIENT} smooth spy activeClass="active" duration={150} style={{ cursor: "pointer" }}>Partner & Client</LinkScroll>
                                                :
                                                <Link to={ROUTE.BASE_URL}>
                                                    Partner & Client
                                                </Link>
                                            }
                                        </div>
                                        <div>
                                            <Link to={ROUTE.NEWS_ARTICLES} onClick={() => isNewsArticles && window.scrollTo(0, 0)}>
                                                News & Articles
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-5 col-md-5 col-sm-12 footer-column">
                                <div className="footer-widget office-widget wow fadeInUp animated" data-wow-delay="400ms" data-wow-duration="1500ms">
                                    <div className="widget-title">
                                        <h4>Office</h4>
                                    </div>

                                    <div className="office-wrapper">
                                        <div className="widget-content">
                                            <h6 style={{ fontWeight: 600, marginBottom: "12px" }}>Head Office</h6>
                                            <div className="text">
                                                <p>
                                                    Menara Citibank Pondok Indah Lt.2, Kebayoran Lama, Jakarta Selatan
                                                </p>
                                            </div>
                                            <div className="account-info-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                                                    <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd" />
                                                </svg>
                                                <Link to="tell:622139720881">+62 21 3972 0881</Link> <br />
                                            </div>
                                            <div style={{ marginTop: "8px" }}></div>
                                            <div className="account-info-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                                                    <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
                                                    <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
                                                </svg>
                                                <Link to="mailto:info@k-egp.com">info@k-egp.com</Link>
                                            </div>
                                        </div>

                                        <div className="widget-content">
                                            <h6 style={{ fontWeight: 600, marginBottom: "12px" }}>Branch Office</h6>
                                            <div className="text">
                                                <p>
                                                    Komplek Ruko Borneo Paradiso Maple D No.1, Balikpapan, Kalimantan Timur
                                                </p>
                                            </div>
                                            <div className="account-info-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                                                    <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd" />
                                                </svg>
                                                <Link to="tell:622139720881">+62 21 3972 0881</Link> <br />
                                            </div>
                                            <div style={{ marginTop: "8px" }}></div>
                                            <div className="account-info-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                                                    <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
                                                    <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
                                                </svg>
                                                <Link to="mailto:info@k-egp.com">info@k-egp.com</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="footer-bottom">
                            <div className="bottom-inner">
                                <div className="copyright">
                                    <p>&copy;&nbsp;2024&nbsp;<Link to="/">K-EGP.</Link>&nbsp;All rights reserved</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default FooterOne;